<template>
    <div class="form c-form c-form-after-list">
        <div style="cursor: pointer" @click="showHideForm">
            <template v-if="!formSent">
                <h4 class="c-question c-question-first">
                    Si no encuentras lo que buscas
                </h4>
                <h5 class="c-question c-question-second">
                    Podemos ayudarte
                </h5>
            </template>
            <template v-else>
                <h4 class="c-question c-question-first">
                    ¡Gracias! Hemos recibido tu solicitud.
                </h4>
                <h5 class="c-question c-question-second">
                    En breve nos pondremos en contacto contigo.
                </h5>
            </template>
            <i class="fas" :class="'fa-chevron-'+(showForm ? 'up' : 'down')"></i>
        </div>
        <div v-show="showForm">
            <div v-if="!formSent">
                <p>
                    Rellena el siguiente formulario y en breve te daremos una respuesta
                </p>
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="Nombre" aria-label="Nombre" v-model="form.nombre"
                           :class="((errors['nombre']) ? 'is-invalid' : '')">
                </div>
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="Móvil" aria-label="Movil" v-model="form.movil"
                           :class="((errors['movil']) ? 'is-invalid' : '')">
                </div>
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="Correo electrónico" aria-label="Correo electrónico"
                           v-model="form.email" :class="((errors['email']) ? 'is-invalid' : '')">
                </div>
                <div class="form-group">
                <textarea type="text" class="form-control" placeholder="¿Qué necesitas?" aria-label="¿Qué necesitas?"
                          v-model="form.mensaje" :class="((errors['mensaje']) ? 'is-invalid' : '')"></textarea>
                </div>
                <p>Al envíar el formulario, aceptas los <a href="/terminos-condiciones">términos y
                    condiciones</a> y la <a href="/politica-privacidad">política de privacidad</a>.</p>
                <b-button class="send-btn" variant="outline-light" @click="submit" :disabled="loading">
                    Enviar
                </b-button>
            </div>
            <div v-else>
                <div class="row button-cols">
                    <div class="col-6">
                        <b-button variant="outline-secondary" @click="resetLine" class="go-new-btn" v-b-tooltip.hover title="Borrar el progreso actual y empezar de nuevo">
                            Empezar de nuevo <img src="/img/iconos/icon_back_budget.svg" alt="Empezar de nuevo" style="height: 1em; margin-top: -0.175rem;">
                        </b-button>
                    </div>
                    <div class="col-6">
                        <b-button variant="outline-secondary" @click="showHideForm" class="go-new-btn">
                            Continuar <i class="fas fa-long-arrow-alt-right"></i>
                        </b-button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "VarietySelectForm",
        data() {
            return {
                showForm: false,
                loading: false,
                form: {
                    nombre: "",
                    movil: "",
                    semana: "",
                    producto: "",
                    type: "help_contact",
                    email: "",
                    mensaje: ""
                },
                formSent: false,
                errors: []
            }
        },
        methods: {
            showHideForm() {
                this.showForm = !this.showForm;
                if (!this.showForm && this.formSent) {
                    this.formSent = false;
                }
            },
            submit() {
                this.loading = true;

                axios.post(this.route('send.contact'), this.form).then(response => {
                    this.errors = [];
                    this.formSent = true;
                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });

                    this.form = {nombre: "", movil: "", email: "", mensaje: ""};
                }).catch(e => {
                    let errors = e.response.data.errors;
                    if (errors) {
                        this.errors = errors;
                    }

                    Vue.toasted.show(e.response.data.info ? e.response.data.info : 'Ha habido un error', {
                        type: "error",
                        duration: 3000
                    });

                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                });
            },
            resetLine() {
                axios.post(this.route('custom.reset-line')).catch((e) => {
                    Vue.toasted.show('Ha ocurrido un error', {
                        type: "error",
                        duration: 3000
                    });
                    console.log(e);
                }).then((response) => {
                    window.location = this.route('custom.type-select');
                });
            }
        }
    }
</script>

<style scoped>
    .c-form {
        padding: 1.5em;
        background-color: #d7db2d;
        margin-top: -5px;
        position: relative;
    }

    .send-btn {
        display: block;
        border-color: #0871b8;
        text-align: center;
        text-decoration: none;
        font-weight: bold;
        color: #0871b8;
        width: 100%;
        cursor: pointer;
        border-radius: 4px;
        border: 2px solid;
        transition: all 0.15s ease;
        padding: 5px;
        max-width: 250px;
        margin: auto;
    }

    .c-form-after-list {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .c-question.c-question-first, .c-question.c-question-second, .fa-chevron-up, .fa-chevron-down {
        color: #0871b8;
    }

    .c-question.c-question-first {
        font-weight: bold;
    }

    .c-question.c-question-first, .c-question.c-question-second {
        margin-bottom: 0.2em;
    }

    input, textarea {
        border-radius: 0;
        font-weight: bold;
    }

    .go-new-btn {
        border-radius: 0;
        color: #0b72b8;
        border: 2px solid #0b72b8;
        font-weight: bold;
        width: 100%;
    }

    .go-new-btn:hover {
        background-color: #c9c9c9;
    }

    .button-cols {
        margin-left: -5px;
        margin-right: -5px;
    }

    .button-cols > .col-6 {
        padding-right: 5px;
        padding-left: 5px;
    }

</style>
